import { Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import SubPage from "@/pages/SubPage";

/**
 * Route map:
 *   /                              → Home
 *   /luna, /ai-front-door, etc.    → SubPage with matching slug
 *
 * We list each sub-page explicitly (rather than a catch-all `/:slug`) so that
 * unknown URLs fall through to the 404 handler. The slug on each route matches
 * the key in `subPagesFallback` and the `slug` field in Sanity.
 */
const SUB_SLUGS = [
  "luna",
  "ai-front-door",
  "steernotes",
  "revenue-cycle-ai",
  "hospital-systems",
  "specialty-groups",
  "ambulatory-surgery-centers",
  "cash-pay-specialty",
  "roi",
  "about",
  "contact",
] as const;

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {SUB_SLUGS.map((slug) => (
        <Route key={slug} path={`/${slug}`} element={<SubPage slug={slug} />} />
      ))}
      <Route path="*" element={<Home />} />
    </Routes>
  );
}
